import * as React from 'react';
import { cn } from '@/lib/utils/cn';

/**
 * Un `<select>` del navegador con la cara del `Select` del kit (misma altura,
 * borde, radio y fondo; los colores del tema, así funciona en oscuro). Queda
 * nativo a propósito en los filtros: se maneja con el teclado como cualquier
 * selector y los tests lo eligen con `selectOptions`.
 */
export const SelectNativo = React.forwardRef<
  HTMLSelectElement,
  React.SelectHTMLAttributes<HTMLSelectElement>
>(({ className, ...props }, ref) => (
  <select
    ref={ref}
    className={cn(
      'h-9 rounded-md border border-input bg-campo px-3 text-sm text-foreground ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
      className
    )}
    {...props}
  />
));
SelectNativo.displayName = 'SelectNativo';
